const messages = {
  title: 'Good'
}

export default messages
